module.exports = __webpack_public_path__ + "img/close_gray.02dcb3dc.svg";